import {type PIXI} from '@colonist/pixi'
import {type UIGameManager} from '../UIGameManager.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {UIHoverActionController} from './UIHoverActionController.ts'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {TileCornerBuildingType} from '@colonist/game-states'
import {type MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {GameStateEnums} from '../../../../../shared/GameEnums.ts'

export class UIKnightUpgradeHoverActionController extends UIHoverActionController {
    private readonly knightPlayerValidator: MechanicValidatorKnightPlayer

    constructor(uiGameManager: UIGameManager, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.Knight)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmUpgradeKnightSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.knightPlayerValidator = knightPlayerValidator
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)

        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated: this.updateState(); break
            default: break
        }
    }

    protected updateState() {
        const action = this.knightPlayerValidator.canPlayerUpgradeKnight()
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getBankActionAmount(locationCornerIndex: number): number | undefined {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex)
        if(knightAtLocation === undefined) return undefined

        return this.knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(knightAtLocation.level + 1)
    }

    getTexture(locationCornerIndex: number): PIXI.Texture {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex)
        if(knightAtLocation === undefined) return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, TileCornerBuildingType.KnightInactiveLevel1)

        const activeState = knightAtLocation.isActivated ? 'Active' : 'Inactive'
        const knightTexture = TileCornerBuildingType[`Knight${activeState}Level${knightAtLocation.level + 1}`]
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture)
    }
}
